import type { CartErrorFragment } from '@shared/shop-api/error/types'

export const toError = (error: CartErrorFragment) => {
  return {
    code: error.code,
    message: error.message,
    field: error.field,
  }
}
